import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Location } from '@angular/common';
import { metaData } from '../../../../metaData';

export interface IMetaDataItem {
  url: string;
  title: string;
  description: string;
  h1String: string;
  keywords: string;
  showEmailSubscription: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class SEOService {
  protected pageData: IMetaDataItem = {
    url: '/',
    title: 'Агентство недвижимости НДВ Супермаркет Недвижимости: недвижимость в Москве и Подмосковье – аренда, продажа, покупка и обмен недвижимости',
    description: 'НДВ Супермаркет Недвижимости - ведущее агентство недвижимости в Москве и Подмосковье, для вас аренда, продажа, покупка и обмен недвижимости на выгодных условиях',
    h1String: 'Квартиры в новостройках',
    keywords: '',
    showEmailSubscription: true,
  };

    constructor(
        private titleSvc: Title,
        private metaSvc: Meta,
        private location: Location
    ) {
    }

    updateMetaData(): void {
      const path = this.location.path();
      for (const itemData of metaData.urlMetaData) {
        if (itemData.url !== path) {
          continue;
        }
        this.pageData = itemData;
        break;
      }
    }

    updatePageMetaData(): void {
      this.updateMetaData();
      this.updateTitle(this.pageData.title)
      this.updateDescription(this.pageData.description);
      this.updateKeywords(this.pageData.keywords);
    }

    updateTitle(title: string): void{
        this.titleSvc.setTitle(title)
    }

    updateDescription(content: string): void {
        this.metaSvc.updateTag({ name: 'description', content })
    }

    updateKeywords(keywords: string): void {
        this.metaSvc.addTag({name: 'keywords', keywords});
    }

    getH1Title(): string {
      if (!this.pageData) {
        this.updateMetaData();
      }
      return this.pageData.h1String;
    }
}
